import {MvsCrudService} from "../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnInit} from "@angular/core";
import {TeTemplateDto} from "../../../../model/dto/entity/te-template.dto";
import {TeTemplateService} from "../../../../service/api/te-template.service";
import {TinymceAutosave} from "../../../../logic/tinymce-autosave";
import {TestCaseChangeEvent, TeTestCaseComponentVariableWithMapping} from "../../te-test-case/te-test-case.component";
import {Subscription} from "rxjs";
import {TeTemplateGenerateResponseDto} from "../../../../model/dto/entity/te-template-generate-response.dto";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {TeTestCaseVariableDto} from "../../../../model/dto/entity/te-test-case-variable.dto";
import {ActivatedRoute, Router} from "@angular/router";
import {TeTemplateVariableService} from "../../../../service/api/te-template-variable.service";
import {ConfirmationService} from "primeng/api";
import {TeVariableTypeEnum} from "../../../../enum/te-variable-type.enum";
import {TeEditorSaveEvent} from "../../te-editor/te-editor.component";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {NavigationItem} from "../../../../../../core/shared/dto/navigation/navigation-item";
import {DtoList} from "../../../../../../core/shared/dto/dto.list";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../../core/shared/object/service/observer.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {ObjectIdentifierWithId} from "../../../../../../core/shared/basic/object-identifier.with.id";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {DtoImportObjectContext} from "../../../../../../core/shared/dto/dto.import.object.context";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {TeEditorCommunicationService} from "../../../../service/te-editor-communication.service";

@Component({
    selector: "te-template-object-base",
    template: '',
    standalone: false
})

export class TeTemplateObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    testCaseService: MvsCrudService;
    testCaseVariablesService: MvsCrudService;
    dto: TeTemplateDto;
    crudService: TeTemplateService;

    widgetBasicData: WidgetData;
    showBasicData: boolean;
    private autoSave = new TinymceAutosave();
    leftSidebarOpen: boolean = false;
    rightSidebarOpen: boolean = false;
    selectedTestCase: TestCaseChangeEvent;
    activeTabEditor: number = 1;
    activeTab1: number = 0;
    queryParamSubscription: Subscription;
    navigationItems: NavigationItem[];

    /** Sub-tabs shown inside the left panel when top-level nav is 'Editor' */
    leftPanelTabs: { label: string; action: string; icon: string }[] = [
        { label: 'Variablen', action: 'Variablen', icon: 'fa-regular fa-folder' },
        { label: 'Artefakte', action: 'Artefakte', icon: 'fa-regular fa-pen-nib' },
        { label: 'Basisdaten', action: 'Basisdaten', icon: 'fa-regular fa-circle-info' },
    ];
    activeLeftPanelTab: { label: string; action: string; icon: string };
    activeLeftPanelTabValue: string = '0';
    splitterSizes: number[] = [30, 70];

    templateGenerateResponse: TeTemplateGenerateResponseDto;
    trustedGenerateResponseHtml: SafeHtml;
    trustedGenerateResponsePdf: SafeHtml;
    occurredException: string;
    occurredExceptionDetails: string;

    generatePdf: boolean = false;
    outputFormatOptions = [
        { label: 'HTML', value: false },
        { label: 'PDF', value: true }
    ];

    testCaseDtoList: DtoList;
    variables: TeTestCaseComponentVariableWithMapping[];
    testCaseVariables: TeTestCaseVariableDto[];

    busy: boolean;
    artefactMap: Record<number, string> = {};

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected route: ActivatedRoute,
        protected router: Router,
        public sanitizer: DomSanitizer,
        protected templateVariableService: TeTemplateVariableService,
        protected templateService: TeTemplateService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService,
        protected editorCommunicationService: TeEditorCommunicationService) {

        super(route);
    }


    ngOnInit() {
        // FIX: Removed redundant `this.activeNavigationItem = this.navigationItems[0]` and
        // `this.onNavigationItems.emit(...)` — super.ngOnInit() handles default selection
        // via the `default: true` flag on the first navigation item.
        super.ngOnInit();

        // Initialize active left panel sub-tab
        this.activeLeftPanelTab = this.leftPanelTabs[0];

        this.testCaseService = this.coreService.getCrudService("te.TeTestCase");
        this.refreshTemplateBasicData();
        this.refreshTestCases();
        this.refreshArtefactMap();

        this.initialized = true;
    }



    /**
     * Save content.
     * @param event
     */
    handleEditorOnSave(event: TeEditorSaveEvent) {

        const dto = new TeTemplateDto();
        dto.id = this.dto.id;
        dto.content = event.content;
        dto.editorTypeEnum = event.editorTypeEnum;

        this.templateService.update(dto).subscribe({
            next: (value) => {
                this.dto.editorTypeEnum = event.editorTypeEnum;
                // FIX: Update dto.content so that when the user switches nav tabs and a new editor instance
                // is created, it receives the latest saved content instead of the stale pre-save content.
                this.dto.content = event.content;
                this.messageService.showSuccessMessageSaved();
                console.log('Updated content data into API');
                let editorContentFromCookie = this.autoSave.getAutoSaveCookie('te.TeTemplateVariable' + this.dto.id);
                if (editorContentFromCookie && dto.content === editorContentFromCookie?.content) {
                    this.autoSave.deleteAutoSaveCookie('te.TeTemplateVariable' + this.dto.id);
                }

            },
            error: (error) => {
                this.messageService.showErrorMessage('Fehler', 'Ein Fehler ist aufgetreten.');
            }
        });

    }


    refreshTemplateBasicData() {
        this.widgetBasicData = WidgetFactory.createWidgetEntityData(
            'te.config.template.view',
            'Template',
            this.objectIdentifier.objectType,
            this.objectIdentifier.objectId
        );
    }

    toggleLeftSidebar() {
        this.leftSidebarOpen = !this.leftSidebarOpen;
    }

    toggleRightSidebar() {
        this.rightSidebarOpen = !this.rightSidebarOpen;
    }

    handleSelectTestCase(event: TestCaseChangeEvent) {
        this.selectedTestCase = event;
    }

    generateTestCaseFn = (id: number, testCaseId: number, generatePdf: boolean, objectVars: any, simpleVars: any,
                          contextScenarios?: {[alias: string]: string}) =>
        this.templateService.generateViaTestCase(id, testCaseId, generatePdf, objectVars, simpleVars, contextScenarios);

    checkNavigationEntryExist(items: NavigationItem[],label: string): boolean {
        const exists = items.find(item => item.label == label);
        if (exists) {
            return true;
        }
        return false;
    }

    handleNavigationItems() {
        this.navigationItems = this.templateService.getObjectComponentNavigationItems();
        this.onNavigationItems.emit(this.navigationItems);
    }

    removeNavItemParam(): void {
        const queryParams = { ...this.route.snapshot.queryParams };
        delete queryParams['navItem'];
        this.router.navigate([], { queryParams: queryParams });
    }

    generateDocument() {

        this.templateGenerateResponse = null;
        this.trustedGenerateResponseHtml = null;
        this.trustedGenerateResponsePdf = null;
        this.occurredException = null;
        this.occurredExceptionDetails = null;

        const objectVariables: { [key: string]: ObjectIdentifierWithId } = {};
        const simpleVariables: { [key: string]: any } = {};

        // fill variables
        if (this.selectedTestCase.variables) {
            for (let variable of this.selectedTestCase.variables) {
                if (variable.useCaseVariable) {
                    if (variable.variableType == "object") {
                        objectVariables[variable.alias] = new ObjectIdentifierWithId(variable.useCaseVariable.objectTypeDtoId, null, variable.useCaseVariable.objectId);
                    } else if (variable.variableType == "simple") {
                        simpleVariables[variable.alias] = variable.useCaseVariable.simpleValue;
                    }
                }
            }
        }

        this.busy = true;

        this.templateService.generateViaTestCase(
            this.dto.id,
            this.selectedTestCase.dto.id,
            this.generatePdf,
            objectVariables,
            simpleVariables).subscribe({
            next: (value) => {
                if (value.errors || value.errorOccurred) {
                    this.occurredException = value.exception;
                    this.occurredExceptionDetails = value.exceptionDetails;
                } else {
                    this.templateGenerateResponse = value;
                    if (this.generatePdf) {
                        this.trustedGenerateResponsePdf = this.sanitizer.bypassSecurityTrustResourceUrl(value.document);
                    } else {
                        this.trustedGenerateResponseHtml = this.sanitizer.bypassSecurityTrustHtml(value.document);
                    }
                }
                this.busy = false;
            },
            error: (error) => {
                this.occurredException = 'Fehler bei der Template-Generierung';
                this.occurredExceptionDetails = error?.error?.message || error?.message || 'Unbekannter Fehler';
                this.busy = false;
            }
        });
    }

    /**
     * Handle variable rename: update template content by replacing old alias with new alias.
     * Updates both the DTO content and the live editor content.
     */
    handleVariableRenamed(event: { oldAlias: string, newAlias: string }) {
        if (event.oldAlias && event.newAlias && event.oldAlias !== event.newAlias) {
            // Update the DTO content
            if (this.dto && this.dto.content) {
                const oldPattern = new RegExp(event.oldAlias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
                this.dto.content = this.dto.content.replace(oldPattern, event.newAlias);
            }
            // Push the replacement to the live editor
            this.editorCommunicationService.replaceAll(event.oldAlias, event.newAlias);
        }
    }

    /**
     * Handle table insert request from the variable tree panel.
     * Opens the table builder dialog via the editor communication service.
     */
    handleTableInsert(variableData: any): void {
        if (variableData) {
            // variableData includes MetaDataJoinDto fields + collectionPath and derivedItemAlias from the tree
            const entityAlias = variableData.joinObjectTypeAlias || variableData.objectTypeDtoName || '';
            const entityId = variableData.joinObjectTypeId || 0;
            // collectionPath is the full FreeMarker path built by walking the tree (e.g., "customer.customerContracts")
            const collectionPath = variableData.collectionPath || '';
            // derivedItemAlias is the loop variable name (e.g., "customerContracts" from the node name)
            const itemAlias = variableData.derivedItemAlias || 'item';
            const collectionLabel = variableData.name || entityAlias;
            this.editorCommunicationService.openTableBuilder(entityAlias, entityId, collectionPath, itemAlias, collectionLabel);
        }
    }

    onNavigationItemChange(navigationItem: NavigationItem): void {
        this.updateSplitterSizes();
    }

    /**
     * Handle sub-tab change in the left panel.
     */
    onLeftPanelTabChange(value: string | number): void {
        this.activeLeftPanelTabValue = String(value);
        const index = parseInt(String(value), 10);
        this.activeLeftPanelTab = this.leftPanelTabs[index];
        this.updateSplitterSizes();
    }

    /**
     * Update splitter panel sizes based on current nav/tab state.
     * Uses a stored array to avoid creating new references on every change detection cycle,
     * which would cause PrimeNG Splitter to reset panels and break drag.
     */
    protected updateSplitterSizes(): void {
        if (this.activeNavigationItem?.action === 'Testen') {
            this.splitterSizes = [40, 60];
        } else {
            this.splitterSizes = [30, 70];
        }
    }

    /**
     * Load template artefacts and build an id->name map for the TinyMCE chip plugin.
     */
    refreshArtefactMap() {
        const templateArtefactService = this.coreService.getCrudService("te.TeTemplateArtefact");
        const objectRequestList = new ObjectRequestList(
            false,
            [FilterCriteria.create("template", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            []
        );

        templateArtefactService.list(objectRequestList).subscribe((response: DtoList) => {
            const map: Record<number, string> = {};
            if (response && response.entries) {
                for (const entry of response.entries) {
                    const artefactId = entry['artefactDtoId'];
                    const artefactName = entry['artefactDtoName'];
                    if (artefactId) {
                        map[artefactId] = artefactName || 'Artefakt #' + artefactId;
                    }
                }
            }
            this.artefactMap = map;
        });
    }

    refreshTestCases() {
        this.testCaseService.list(ObjectRequestList.createSimple(DtoImportObjectContext.createEmpty())).subscribe(value => {
            this.testCaseDtoList = value;
            this.busy = false;
        });
    }

    refreshTestCaseVariables() {

        const dtoListRequest = new ObjectRequestList(
            false,
            [FilterCriteria.create('testCase', FilterCriteria.cOperatorEqual, this.selectedTestCase.dto.id, null)],
            []
        );

        this.testCaseVariablesService.list(dtoListRequest).subscribe(res => {
            this.testCaseVariables = res.entries;
            this.refreshVariableMapping();
        });

    }

    refreshVariableMapping() {

        if (!this.selectedTestCase.variables) {
            return;
        }

        for (let variable of this.selectedTestCase.variables) {

            // set tu null
            variable.useCaseVariable = null;

            if (!this.testCaseVariables) {
                continue;
            }


            for (let testCaseVariable of this.testCaseVariables) {

                // check whether alias is set
                if (testCaseVariable.alias && testCaseVariable.alias !== variable.alias) {
                    continue;
                }

                // check whether types are matching
                if (variable.variableType == "object" && (testCaseVariable.type != TeVariableTypeEnum.object || variable.objectTypeDtoId != testCaseVariable.objectTypeDtoId)){
                    continue;
                } else if (variable.variableType == "simple" && testCaseVariable.type != TeVariableTypeEnum.simple){
                    continue;
                }


                let isMatch: boolean = false;

                // check for perfect match (including alias)
                if (variable.variableType == "object") {
                    if (variable.objectTypeDtoId && variable.objectTypeDtoId == testCaseVariable.objectTypeDtoId) {
                        isMatch = true;
                    }
                } else if (variable.variableType == "simple") {
                    isMatch = true;
                }

                variable.useCaseVariable = testCaseVariable;

                if (testCaseVariable.alias) {
                    // perfect match, we can stop any further processing
                    break;
                }

            }

        }

    }


}